import {connect} from 'react-redux';
import LabelStageNames from './LabelStageNames';
import {prevCompletedStepSignTrue} from "../../actions/prevCompletedStepSign/prevCompletedStepSignTrue";
import {getSpecificStep} from "../../actions/getSpecificStep";


const mapStateToProps = ({
                           regType: {regType},
                           nextStep: {desktopCompletedStages}
                         }) => ({
  regType,
  desktopCompletedStages
});

export default connect(
  mapStateToProps,
  {prevCompletedStepSignTrue, getSpecificStep}
)(LabelStageNames);
